import DrawTouch from 'ol-ext/interaction/DrawTouch'

import { unByKey } from 'ol/Observable'
import MultiPoint from 'ol/geom/MultiPoint'
import { Circle, Fill, Stroke, Style, RegularShape } from 'ol/style'

const drawTouchStyle = [
  new Style({ zIndex: Infinity, image: new Circle({ radius: 12, snapToPixel: true, stroke: new Stroke({ color: 'rgba(255, 255, 255, 0.6)', width: 5 }) }) }),
  new Style({ zIndex: Infinity, image: new RegularShape({ points: 4, radius: 16, radius2: 0, snapToPixel: true, stroke: new Stroke({ color: 'rgba(255, 255, 255, 0.6)', width: 3 }) }) }),
  new Style({ zIndex: Infinity, image: new Circle({ radius: 12, snapToPixel: true, stroke: new Stroke({ color: 'red', width: 2 }) }) }),
  new Style({ zIndex: Infinity, image: new RegularShape({ points: 4, radius: 16, radius2: 0, snapToPixel: true, stroke: new Stroke({ color: 'red', width: 1 }) }) }),
]

class CustomDrawTouch extends DrawTouch {
  constructor (options) {
    options = options || { }
    const white = [255, 255, 255, 1]
    const editColor = [0, 153, 255, 1]
    const sketchColor = [255, 0, 0, 1]
    const width = 3
    // on utilise self car on ne peut pas utiliser this avant la méthode super()
    let self = null
    // TODO étendre target afin d'utiliser le padding et ne plus utiliser "sketchstyle" pour dessiner la target
    const optOptions = {
      ...{
        targetStyle: [], // vu qu'on a un padding on mets un style vide pour la target, le style est géré ci-dessous dans le tableau des sketch-style (drawTouchStyle.concat([...])
        style: [
        // points (conditionné sur l'edition de point)
          new Style({
            image: new Circle({
              radius: width * 2,
              fill: new Fill({
                color: editColor,
              }),
              stroke: new Stroke({
                color: white,
                width: width / 2,
              }),
            }),
            zIndex: Infinity,
            geometry: function (feature) {
              if (options.type !== 'Point') { return null }
              return feature.getGeometry()
            },
          }),
          // lignes (conditionné sur l'edition de ligne et affichage des lignes de construction)
          new Style({
            stroke: new Stroke({
              color: white,
              width: width + 2,
            }),
            geometry: function (feature) {
              if (options.type === 'Point' || !self.showConstructionLine_) { return null }
              return feature.getGeometry()
            },
          }),
          new Style({
            stroke: new Stroke({
              color: editColor,
              width,
            }),
            geometry: function (feature) {
              if (options.type === 'Point' || !self.showConstructionLine_) { return null }
              return feature.getGeometry()
            },
          }),
          // polygone (conditionné sur l'edition de ligne et affichage des lignes de construction)
          new Style({
            fill: new Fill({
              color: [255, 255, 255, 0.5],
            }),
            geometry: function (feature) {
              if (options.type !== 'Polygon' || !self.showConstructionLine_) { return null }
              return feature.getGeometry()
            },
          }),
          // points de construction (conditionné sur l'edition de ligne ou polygone et affichage des points de construction)
          new Style({
            image: new Circle({
              radius: width * 2,
              fill: new Fill({
                color: editColor,
              }),
              stroke: new Stroke({
                color: white,
                width: width / 2,
              }),
            }),
            zIndex: Infinity,
            geometry: function (feature) {
              if (feature.getGeometry() === null || feature.getGeometry().getType() === 'Point' || !self.showConstructionPoint_) { return null }
              const coordinates = feature.getGeometry().getType() === 'LineString' ? feature.getGeometry().getCoordinates() : feature.getGeometry().getCoordinates()[0]
              return new MultiPoint(coordinates)
            },
          }),
        ],
        sketchStyle: drawTouchStyle.concat([
        // lignes (conditionné sur l'edition de ligne/polygone et affichage des lignes de construction)
          new Style({
            stroke: new Stroke({
              color: white,
              width: width + 2,

            }),
            geometry: function (feature) {
              if (options.type === 'Point' || !self.showConstructionLine_) { return null }

              return feature.getGeometry()
            },
          }),
          new Style({
            stroke: new Stroke({
              color: sketchColor,
              width,
              lineDash: [10, 10],
            }),
            geometry: function (feature) {
              if (options.type === 'Point' || !self.showConstructionLine_) { return null }
              return feature.getGeometry()
            },
          }),
          // polygone (conditionné sur l'edition de ligne et affichage des lignes de construction)
          new Style({
            fill: new Fill({
              color: [255, 255, 255, 0.5],
            }),
            geometry: function (feature) {
              if (options.type !== 'Polygon' || !self.showConstructionLine_) { return null }
              return feature.getGeometry()
            },
          }),
          // points de construction (conditionné sur l'edition de ligne ou polygone et affichage des points de construction)
        /* new Style({
          image: new Circle({
            radius: width * 2,
            fill: new Fill({
              color: sketchColor,
            }),
            stroke: new Stroke({
              color: white,
              width: width / 2,
            }),
          }),
          zIndex: Infinity,
          geometry: function (feature) {
            if (feature.getGeometry().getType() === 'Point' || !this.showConstructionPoint_) { return null }
            const coordinates = feature.getGeometry().getType() === 'LineString' ? feature.getGeometry().getCoordinates() : feature.getGeometry().getCoordinates()[0]
            return new MultiPoint(coordinates)
          }.bind(this),
        }), */
        ]),
      },
      ...options,
    }

    super(optOptions)

    self = this
    if (!options.viewer) {
      console.error('[CustomDrawTouch] options.viewer non présent')
      return
    }

    this.padding_ = null
    this.viewer = options.viewer

    this.setDigitalizeOptions(options)
    this.sketch.setZIndex(Infinity)
    this.needAbortEvent = true
    this.sketch.on(['drawend'], () => {
      this.needAbortEvent = true
    })
    this.sketch.on(['drawstart'], () => {
      this.needAbortEvent = false
    })

    // surcharge le style du layer du sketch qui ne prend pas de fonction par défaut..
    this.sketch.setStyle((feature, resolution) => {
      return (feature.get('sketch')
        ? typeof optOptions.sketchStyle === 'function' ? optOptions.sketchStyle(feature, resolution) : optOptions.sketchStyle
        : typeof optOptions.style === 'function' ? optOptions.style(feature, resolution) : optOptions.style)
    })
  }
}

CustomDrawTouch.prototype.setMap = function (map) {
  unByKey(this.moveListener)

  if (this._listener) {
    Object.values(this._listener).forEach(unByKey)
  }

  DrawTouch.prototype.setMap.call(this, map)
  if (map) {
    let isMovingCenter = false
    this.moveListener = map.on('moveend', (evt) => {
      let coordinates = this.getPosition()
      if (this.snapOptions_ && !isMovingCenter) {
        const pixel = map.getPixelFromCoordinate(coordinates)
        const result = this.viewer.getFeatureSnapper().snapTo(pixel, coordinates, this.snapOptions_)
        if (result) {
          coordinates = result.vertex.slice(0, 2)
          isMovingCenter = true
          map.once('moveend', (evt) => {
            isMovingCenter = false
          })
          // permet au centre de bien se caler (this._pos est une variable interne de center_touch)
          this.pos_ = coordinates
          map.getView().setCenter(coordinates)
        }
      }
      this.sketch.getSource().getFeatures()[0].changed()
    })
  }
}

CustomDrawTouch.prototype.setDigitalizeOptions = function (options) {
  // Nombre max de point de la géométrie
  this.maxPoints_ = options.maxPoints ? options.maxPoints : null
  this.showConstructionPoint_ = typeof options.showConstructionPoint === 'boolean' ? options.showConstructionPoint : false
  this.showConstructionLine_ = typeof options.showConstructionLine === 'boolean' ? options.showConstructionLine : true
  this.snapOptions_ = options.snapOptions ? options.snapOptions : null
}

CustomDrawTouch.prototype.setSnapOptions = function (snapOptions) {
  this.snapOptions_ = snapOptions || null
}

/** Annule le dessin en court */
CustomDrawTouch.prototype.abortDrawing = function () {
  this.sketch.abortDrawing()
  // drawTouch ne lance pas l'event drawabort si le dessin n'a pas commencé..
  if (this.needAbortEvent) {
    this.dispatchEvent({ type: 'drawabort' })
  }
  this.needAbortEvent = true
}

/** Ajoute un padding pour que la position soit au centre même si un menu est ouvert */
CustomDrawTouch.prototype.setPadding = function (padding) {
  this.padding_ = padding
}

CustomDrawTouch.prototype.getPosition = function () {
  let position = DrawTouch.prototype.getPosition.call(this)

  if (this.padding_ && this.getMap()) {
    const [sizex, sizey] = this.getMap().getSize()
    const pixelX = (sizex / 2) + (this.padding_[3] / 2) - (this.padding_[1] / 2)
    const pixelY = (sizey / 2) + (this.padding_[2] / 2) - (this.padding_[0] / 2)
    position = this.getMap().getCoordinateFromPixel([pixelX, pixelY])
  }
  return position
}

CustomDrawTouch.prototype.getListPoint = function () {
  let listPoints = []
  if (this.sketch.getFeature().getGeometry() === null) { return [] }

  switch (this.sketch.getFeature().getGeometry().getType()) {
    case 'Point':
      listPoints = [this.sketch.getFeature().getCoordinates()]
      break
    case 'LineString':
      listPoints = this.sketch.getFeature().getGeometry().getCoordinates()
      break
    case 'Polygon':
      listPoints = this.sketch.getFeature().getGeometry().getCoordinates()[0]
      break
    default:
  }
  return listPoints
}

CustomDrawTouch.prototype.hasReachedMaxPoints = function () {
  if (this.maxPoints_ === null || isNaN(this.maxPoints_)) { return false }
  let maxPoints = 0
  switch (this.getGeometryType()) {
    case 'Point':
      maxPoints = 1
      break
    case 'LineString':
      maxPoints = Math.max(this.maxPoints_, 2)
      break
    case 'Polygon':
      maxPoints = Math.max(this.maxPoints_, 3)
      break
    default:
      return false
  }
  const listPoints = this.getListPoint()
  return listPoints.length >= maxPoints
}

CustomDrawTouch.prototype.addPoint = function () {
  // si on a atteinds le nombre max de point du paramétrage  on termine le dessin au prochain ajout de point
  if (this.hasReachedMaxPoints()) {
    this.finishDrawing()
    return
  }

  DrawTouch.prototype.addPoint.call(this)
  // renvoit le nombre de point pour le reflecter sur une IHM par exemple
  const listPoints = this.getListPoint()
  this.dispatchEvent({ type: 'listpoint:change', listPoints, geomtype: this.getGeometryType() })
}

CustomDrawTouch.prototype.removeLastPoint = function () {
  DrawTouch.prototype.removeLastPoint.call(this)

  // renvoit le nombre de point pour le reflecter sur une IHM par exemple
  const listPoints = this.getListPoint()
  this.dispatchEvent({ type: 'listpoint:change', listPoints, geomtype: this.getGeometryType() })
}

CustomDrawTouch.prototype.finishDrawing = function () {
  // dans le cas du point, lorsque l'utilisateur veut "finir" on se dit qu'il faut terminer en créant, donc on ajoute le point
  // cela va déclencer le drawend
  if (this.getGeometryType() === 'Point') {
    this.addPoint()
    return
  }
  // autre cas (ligne, polygone), on ajoute un point si possible puis on termine
  // si il fallait plus d'un point on ne fait rien
  let minPoints = 0
  switch (this.getGeometryType()) {
    case 'LineString':
      minPoints = 1
      break
    case 'Polygon':
      minPoints = 2
      break
    default:
      return
  }

  const listPoints = this.getListPoint()
  if (listPoints.length < minPoints) {
    this.addPoint()
  }

  DrawTouch.prototype.finishDrawing.call(this)
}

export default CustomDrawTouch
